module.exports = __webpack_public_path__ + "img/tablet2.3043d01b.png";